import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  ArrowLeft, 
  QrCodeScan, 
  Speedometer2, 
  BoxArrowInRight,
  Grid3x3Gap
} from 'react-bootstrap-icons';
import { signOut1 } from '../firebase';

const Header = ({ 
  title = '',
  showBack = true,
  backPath = '/',
  showDashboard = true,
  showSignOut = true,
  onBackClick
}) => {
  const navigate = useNavigate();

  const handleBackClick = (e) => {
    if (onBackClick) {
      e.preventDefault();
      onBackClick();
    }
  };

  const handleSignOut = async (e) => {
    e.preventDefault();
    try {
      await signOut1();
      navigate('/');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <div className="header-left">
          {showBack && (
            <Link 
              to={backPath} 
              className="header-btn"
              onClick={handleBackClick}
              title="Go Back"
            >
              <ArrowLeft size={25} />
            </Link>
          )}
          {showDashboard && (
            <Link 
              to="/dashboard" 
              className="header-btn"
              title="Dashboard"
            >
              <Grid3x3Gap size={25} />
            </Link>
          )}
        </div>
        
        <div className="header-center">
          <div className="logo-container">
            <img className="app-logo" alt="bobmc" src="Logo.png" />
          </div>
          {title && (
            <h2 className="">{title}</h2>
          )}
        </div>

        <div className="header-actions">
          {showSignOut && (
            <button 
              className="header-btn" 
              onClick={handleSignOut}
              title="Sign Out"
            >
              <BoxArrowInRight size={20} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;